/*
* Uses the browser provided latitude and longitude to lookup the associated zipcode via Google's Geocoder API
* returns zip code as a String, e.g. "90210"
*/
// function getZipCode() {
//     navigator.geolocation.getCurrentPosition((position) => {
//         let lat = position.coords.latitude;
//         let long = position.coords.longitude;
//         let latlng = {
//             lat: parseFloat(lat),
//             lng: parseFloat(long),
//         };

//         const geocoder = new google.maps.Geocoder();
//         geocoder
//         .geocode({ location: latlng })
//             .then((response) => {
//                 if (response.results[0]) {
//                     let zipInfo = response.results[0].address_components.find(function (component) {
//                         return component.types[0] == "postal_code";
//                     });
//                     let zipCode = zipInfo.long_name;
//                     const event = new CustomEvent("customer:zip_identified", { detail: zipCode });
//                     document.dispatchEvent(event);
//                 }
//             })
//         .catch((e) => window.alert("Geocoder failed due to: " + e));
//     },
//     (error) => {
//         if (error.code == error.PERMISSION_DENIED) {
//             const event = new CustomEvent("customer:location_permission_denied");
//             document.dispatchEvent(event);
//         }
//     });
// }
/*
* Checks to see if zip code entered is in the 12 state footprint
* 5xxxx covers 6 States: MT, ND, SD, MN, IA, WI
* 6xxxx covers 4 States: NE, KS, MO, IL
* 48xxx and 49xxx covers MI
* 82xxx and 831xx covers WY
*/
function checkExtendedCoverage(evaluateZip,address) {
    if(evaluateZip.length==0 || address.country!="US"){console.log("Invalid Zip: "+address.city+" "+address.region+" "+address.country)}
    else{
    console.log(address.city +" "+ address.region +" "+address.country)
    return (evaluateZip.startsWith("5")||evaluateZip.startsWith("6")||evaluateZip.startsWith("48")||evaluateZip.startsWith("49")||evaluateZip.startsWith("82")||evaluateZip.startsWith("831"))
  }
  }
  
  function getCurrentPosition() {
      return new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
      });
  }
  
  function getZipCode() {
      getCurrentPosition()
          .then((position) => {
              let lat = position.coords.latitude;
              let long = position.coords.longitude;
              let latlng = {
                  lat: parseFloat(lat),
                  lng: parseFloat(long),
              };
  
              const geocoder = new google.maps.Geocoder();
              return geocoder.geocode({ location: latlng }); // Return the promise
          })
          .then((response) => {
              if (response.results[0]) {
                  let zipInfo = response.results[0].address_components.find((component) => {
                      return component.types.includes("postal_code");
                  });
  
                  if (zipInfo && zipInfo.long_name) {
                      let zipCode = zipInfo.long_name;
                      const event = new CustomEvent("customer:zip_identified", { detail: zipCode });
                      document.dispatchEvent(event);
                  } else {
                      console.error("Postal code not found in address components.");
                  }
              } else {
                  console.error("No results found from geocoding.");
              }
          })
          .catch((error) => {
              // Handle errors from either geolocation or geocoding
              if (error.code === error.PERMISSION_DENIED) {
                  const event = new CustomEvent("customer:location_permission_denied");
                  document.dispatchEvent(event);
              } else {
                  console.error("Error:", error);
              }
          });
  }
  
  /*
  * Saves zip code and store information in a cookie
  */
  function saveLocation(slumberlandData) {
      const cookieName = "slumberland-geo";
      const cookieData = slumberlandData;
      const d = new Date();
      const numberOfDays = 1;
      d.setTime(d.getTime() + (numberOfDays*24*60*60*1000));
      let expires = "expires="+ d.toUTCString();
      document.cookie = cookieName + "=" + JSON.stringify(cookieData) + ";" + expires + ";path=/";
  }
  
  /*
  * Gets the contents of the slumberland-geo cookie
  */
  function getCookieData(cookieName) {
      let name = cookieName + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let cookieArray = decodedCookie.split(';');
      for(let i = 0; i <cookieArray.length; i++) {
          let cookie = cookieArray[i];
          while (cookie.charAt(0) == ' ') {
              cookie = cookie.substring(1);
          }
          if (cookie.indexOf(name) == 0) {
              return cookie.substring(name.length, cookie.length);
          }
      }
      return null;
  }
  
  /*
  * Gets the customer's nearby stores from yext
  * Documentation: https://hitchhikers.yext.com/docs/contentdeliveryapis/legacy/entities
  * Example request URL: https://cdn.yextapis.com/v2/accounts/me/entities/geosearch?api_key=d19a7bf02d89e1718835a43d3cea0c77&v=20240402&location="50047"&radius=30&limit=5
  */
  function getNearbyStoresGEO(postal_code) {
      const yextEndpoint = "https://cdn.yextapis.com/v2/accounts/me/entities/geosearch";
      const yextApiKey = "d19a7bf02d89e1718835a43d3cea0c77";
      const version = "20240402";
      let url = `${yextEndpoint}?api_key=${yextApiKey}&v=${version}&location=${postal_code}&radius=30&limit=5`;
  
      fetch(url)
        .then(response => response.json())
        .then(data => {
            const event = new CustomEvent("yext:nearby_stores_available_geo", { detail: data.response });
            document.dispatchEvent(event);
        })
        .catch(error => {
          console.error('Error fetching nearbyStores:', error);
      });
  }
  
  /*
  * Takes in a stores military hours (15) and returns a standard time string (3PM)
  */
  function convertToStandardTime(militaryTime) {
      let standardTime = militaryTime;
      let meridian = 'PM';
      if (militaryTime > 12) {
          standardTime = militaryTime - 12;
      } else if (militaryTime < 12) {
          meridian = 'AM';
      }
      return standardTime + meridian;
  }
  
  /*
  * Takes in a stores hours and returns a date message
  */
  function getDateMessage(storeHours) {
      const dayMap = {
          '0': 'Sunday',
          '1': 'Monday',
          '2': 'Tuesday',
          '3': 'Wednesday',
          '4': 'Thursday',
          '5': 'Friday',
          '6': 'Saturday',
      }
      const date = new Date();
      const currentDayNumber = date.getDay(); // returns the day as an integer
      const currentDayName = dayMap[currentDayNumber]; // returns the day name (currentDayNumber 0 returns 'sunday')
      const tomorrowDayName = dayMap[((currentDayNumber + 1)%7? currentDayNumber + 1 : 0)]; // returns the day name (currentDayNumber 0 returns 'sunday')
      const currentHour = date.getHours(); // returns the current hour (4:00am returns 4, 3:00pm returns 15)
      const storeOpenToday = Number(storeHours[currentDayName.toLowerCase()].openIntervals[0].start.split(':')[0]);
      const storeCloseToday = Number(storeHours[currentDayName.toLowerCase()].openIntervals[0].end.split(':')[0]);
      const storeOpenTomorrow = Number(storeHours[tomorrowDayName.toLowerCase()].openIntervals[0].start.split(':')[0]);
      let dateMessage = '';
  
      // figure out if current time is before, within, or after today's store hours
      if (currentHour < storeOpenToday) {
          // display the store opening time
          dateMessage = window.slumberland.messages.opens_at + ' ' + convertToStandardTime(storeOpenToday);
      } else if (currentHour >= storeOpenToday && currentHour <= storeCloseToday) {
          //display closing time
          dateMessage = window.slumberland.messages.open_until + ' ' + convertToStandardTime(storeCloseToday);
      } else {
          // display tomorrow's opening time
          dateMessage = window.slumberland.messages.opens_at + ' ' + convertToStandardTime(storeOpenTomorrow) + ' ' + tomorrowDayName;
      }
      return dateMessage;
  }
  
  /*
  * Updates the UI with customer geolocation and assigned store data
  */
  function updateDOM() {
      // Display Zip Code //
      let elGeoZips = document.getElementsByClassName("geo-zip-code");
      const zipCode = window.slumberland.customer.zipCode;
      const nearbyStores = window.slumberland.nearbyStores;
    
      if (zipCode && nearbyStores && nearbyStores.length > 0) {
          for ( elZip of elGeoZips ) {
              elZip.innerHTML = zipCode;
              elZip.classList.remove('hide');
          }
          if(nearbyStores && nearbyStores.length > 0) {
            // hide the store unavailable messaging
            //let elNoStores = document.getElementsByClassName("js-geo-store-unavailable, js-geocode-extended-shipping");
            let elNoStores = document.querySelectorAll('.js-geo-store-unavailable, .js-geocode-extended-shipping');
            for ( elNoStore of elNoStores ) {
                elNoStore.classList.add('hide');
            }
            let matchedElements = document.querySelectorAll('.js-geocode-store,.js-geocode-delivery,.js-geocode-divider');
            for ( element of matchedElements ) {
                element.classList.remove('hide');
            }
          }
      } else if(zipCode) {
         for ( elZip of elGeoZips ) {
              elZip.innerHTML = zipCode;
              elZip.classList.remove('hide');
          }
      }
  
      // Display Store Name //
      let customerStoreId = window.slumberland.customer.storeId;
      if (customerStoreId && 'nearbyStores' in window.slumberland) {
          let elGeoStores = document.getElementsByClassName("geo-store");
          let current_store;
          for (_nearbyStore of window.slumberland.nearbyStores) {
            if(_nearbyStore.meta.id == customerStoreId) {
              current_store = _nearbyStore;
              break;
            }
          }
  
          if(current_store) {
            for ( elStore of elGeoStores ) {
                elStore.innerHTML = current_store.geomodifier;
                if (elStore.id == "header-geo-store") {
                  elStore.innerHTML = `<a href="${current_store.c_pagesURL}" target="_blank">${current_store.geomodifier}<a/>`;
                } 
                else {
                  elStore.innerHTML = `<modal-opener class="no-js-hidden" data-modal="modal-see-in-store"><button style="text-decoration:underline; font-weight: 700;">See in Store?</button></modal-opener>`;
                }
                elStore.dataset.url = current_store.c_pagesURL;
                elStore.classList.remove('hide');
            }
            // hide the store unavailable messaging
            let elNoStores = document.getElementsByClassName("js-geo-store-unavailable, js-geocode-extended-shipping");
            for ( elNoStore of elNoStores ) {
                elNoStore.classList.add('hide');
            }
            // display store hours
            let dateMessage = getDateMessage(current_store.hours);
            document.getElementById('open-message').innerHTML = dateMessage;
          }
      }
  
      // Display Zip Code Unavailable Messaging //
      if (!zipCode) {
          let elDeliveryUnavailability = document.getElementsByClassName("delivery-unavailability");
          for ( element of elDeliveryUnavailability ) {
              element.innerHTML = element.dataset.noZip;
          }
      } else if (!customerStoreId) { // Display Store Unavailable Messaging //
          let elDeliveryUnavailability = document.getElementsByClassName("delivery-unavailability");
          for ( element of elDeliveryUnavailability ) {
              element.innerHTML = element.dataset.noDelivery;
          }
      }
  
      // Display Unavailable Data Messaging //
      if (!customerStoreId || !zipCode) {
          let elNoStores = document.getElementsByClassName("js-geo-store-unavailable");
          for ( elNoStore of elNoStores ) {
              elNoStore.classList.remove('hide');
          }
          let matchedElements = document.querySelectorAll('.js-geocode-store,.js-geocode-delivery,.js-geocode-divider,.js-geocode-extended-shipping');
          for ( element of matchedElements ) {
              element.classList.add('hide');
          }
      }
  
      // Display Extended Available Data Messaging //
      if (customerStoreId == 'Z1') {
          let elNoStores = document.getElementsByClassName("js-geocode-extended-shipping");
          for ( elNoStore of elNoStores ) {
              elNoStore.classList.remove('hide');
          }
          let matchedElements = document.querySelectorAll('.js-geocode-store,.js-geocode-delivery,.js-geocode-divider,.js-geo-store-unavailable');
          for ( element of matchedElements ) {
              element.classList.add('hide');
          }
      }
  
      // Display Cart Messaging //
      let elCartMessage = document.getElementById('cart-geolocation-message');
      if (elCartMessage) {
          let message = '';
          if (slumberland.customer.storeId) {
              message = elCartMessage.dataset.available + ' ' + slumberland.customer.zipCode;
              elCartMessage.innerHTML = message;
          } else {
              message = `<div>${elCartMessage.dataset.unavailable} ${slumberland.customer.zipCode}, </div><div>${elCartMessage.dataset.storepickup}</div>`;
              elCartMessage.innerHTML = message;
          }
      }
  }
  
  /*
  * Handles click events on geolocation elements
  */
  function handleClickEvents() {
      let elHeaderGeoZipCodeForm = document.getElementById('header-geo-zip-form');
      let elPdpGeoZipCodeForm = document.getElementById('pdp-geo-zip-form');
  
      let elGeoZipCodes = document.getElementsByClassName('geo-zip-code');
      let elGeoZipCodesEdit = document.getElementsByClassName('geo-zip-edit');
      let elGeoElements = Array.from(elGeoZipCodes).concat(Array.from(elGeoZipCodesEdit));
    
      for ( elGeoZipCode of elGeoElements) {
          elGeoZipCode.addEventListener('click', function(e) {
              if (this.dataset.location == "header") {
                  modifySiblings(elHeaderGeoZipCodeForm, 'add', 'js-zip-form-active');
  
                  elHeaderGeoZipCodeForm.classList.remove('hide');
                  let zipInput = elHeaderGeoZipCodeForm.getElementsByClassName('geo-zip-input')[0];
                  zipInput.focus();
              } else {
                  modifySiblings(elPdpGeoZipCodeForm, 'add', 'js-zip-form-active');
  
                  elPdpGeoZipCodeForm.classList.remove('hide');
                  let zipInput = elPdpGeoZipCodeForm.getElementsByClassName('geo-zip-input')[0];
                  zipInput.focus();
              }
          });
      }
  
      elHeaderGeoZipCodeForm.addEventListener('submit', handleZipSubmit);
      if (elPdpGeoZipCodeForm)
          elPdpGeoZipCodeForm.addEventListener('submit', handleZipSubmit);
  
      function handleZipSubmit(e) {
          e.preventDefault(); //prevent the form from submitting so that we can override the default behavior
          this.classList.add('hide');
          modifySiblings(this, 'remove', 'js-zip-form-active');
  
          let zipInput = this.getElementsByClassName('geo-zip-input')[0];
          if (isValidUSZipCode(zipInput.value)) {
            const event = new CustomEvent("customer:zip_identified", { detail: zipInput.value });
            document.dispatchEvent(event);
          }
      }
  
      if(elHeaderGeoZipCodeForm) {
        elHeaderGeoZipCodeForm.addEventListener('focusout', function(event) {
            if (!elHeaderGeoZipCodeForm.contains(event.relatedTarget)) {
                // Handle the form losing focus
                elHeaderGeoZipCodeForm.classList.add('hide');
                modifySiblings(elHeaderGeoZipCodeForm, 'remove', 'js-zip-form-active');
            }
        });
      }
      if(elPdpGeoZipCodeForm) {
        elPdpGeoZipCodeForm.addEventListener('focusout', function(event) {
            if (!elPdpGeoZipCodeForm.contains(event.relatedTarget)) {
                // Handle the form losing focus
                elPdpGeoZipCodeForm.classList.add('hide');
                modifySiblings(elPdpGeoZipCodeForm, 'remove', 'js-zip-form-active');
            }
        });
      }
  }
  
  function isValidUSZipCode(zip) {
    const zipCodePattern = /^\d{5}(-\d{4})?$/;
    return zipCodePattern.test(zip);
  }
  
  /*
  * Utility function for getting child elements with the ability to skip an element
  */
  function modifyChildren(n, skipMe, modification, className){
      for ( ; n; n = n.nextSibling )
         if ( n.nodeType != null && n.nodeType == 1 && n != skipMe)
              if(modification == 'add')
                  n.classList.add(className)
              else
                  n.classList.remove(className)
  };
  
  /*
  * Utility function for getting sibling elements
  */
  function modifySiblings(n, modification, className) {
      return modifyChildren(n.parentNode.firstChild, n, modification, className);
  }
  
  /*
  * Utility function for adding class to elements
  */
  function addClassToElements(elementList, className) {
      for (element of elementList) {
          element.classList.add = className;
      }
  }
  
  /*
  * Utility function for removing class to elements
  */
  function removeClassFromElements(elementList, className) {
      for (element of elementList) {
          element.classList.remove = className;
      }
  }
  
  function getSessionIP() {
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
             window.slumberland.customer.ip = data.ip;
        })
        .catch(error => {
          console.error('Error fetching IP address:', error);
        });
    }
  
  /*
  * Initializes geolocation feature
  */
  function init() {
      const cookieName = "slumberland-geo";
      //check to see if location was already saved in cookie
      let savedData = getCookieData(cookieName);
      // if location was saved, hydrate the global state by merging with stored data
      if(savedData) {
          window.slumberland.customer = Object.assign({}, window.slumberland.customer, JSON.parse(savedData));
          if('zipCode' in window.slumberland.customer && window.slumberland.customer.zipCode) {
            getNearbyStoresGEO(window.slumberland.customer.zipCode);
            //updateDOM();
          }
      }
      if('customer' in window.slumberland && !('ip' in window.slumberland.customer)) {
          getSessionIP();
       }
      // if location hasn't been saved, try to get it via browser geolocation and google's reverse geocoding
      if(!savedData || !window.slumberland.customer.zipCode){
          // for improved site performance we only load the google maps api in the event that the users zipcode is unknown
          var script = document.createElement('script');
          script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDqKlDSGbjdlLGOwPK9h2AaSD2r-9yFuFs&callback=getZipCode&v=weekly';
          document.head.appendChild(script);
      }
      document.addEventListener("customer:zip_identified",(e)=>{
          let zipCode = e.detail;
          if(zipCode) {
            getNearbyStoresGEO(zipCode)
          }
          window.slumberland.customer.zipCode = zipCode;
      },
      false,
      );
      // yext has returned the store details
      document.addEventListener("yext:nearby_stores_available_geo",(e)=>{
          let nearbyStores = e.detail.entities;
  
              if(nearbyStores && nearbyStores.length > 0) {
              window.slumberland.nearbyStores = nearbyStores;
              window.slumberland.customer.nearbyStores = [];
              nearbyStores.every(function(store) {
                  window.slumberland.customer.nearbyStores.push(store.meta.id);
                  return true;
              });
              
              // The first store returned is always the geographical closest based on postal code from Yext.
              window.slumberland.customer.storeId = nearbyStores[0].meta.id;
              window.slumberland.geo_changed = 1;
              saveLocation(window.slumberland.customer);
              updateDOM();
            console.log(e.detail.geo.address.postalCode + " nearest store and info")
                
          }  
              
              else if(checkExtendedCoverage(e.detail.geo.address.postalCode, e.detail.geo.address)){
              window.slumberland.customer.storeId = 'Z1';
              window.slumberland.customer.nearbyStores = [];
              window.slumberland.nearbyStores = [];
              window.slumberland.geo_changed = 1;
              saveLocation(window.slumberland.customer);
              updateDOM();
              console.log(e.detail.geo.address.postalCode + " extended area coverage case")
                }
  
                else{      
              // No stores found, show unavailable delivery area.
              window.slumberland.customer.storeId = '';
              window.slumberland.customer.nearbyStores = [];
              window.slumberland.nearbyStores = [];
              window.slumberland.geo_changed = 1;
              saveLocation(window.slumberland.customer);
              updateDOM();
              console.log(e.detail.geo.address.postalCode + " pickup only message - out of 12 state footprint or invalid zip")
          }
         
                                
      },
      false,
      );
      // handles location permission denied
      document.addEventListener("customer:location_permission_denied",(e)=>{
          updateDOM();
      },
      false,
      );
      handleClickEvents();
  }
  
  init();